import HomeIcon from '@/components/icon/icons/navbar/Home-icon.vue'
import TasksIcon from '@/components/icon/icons/navbar/Tasks-icon.vue'
import AgreementsIcon from '@/components/icon/icons/navbar/Agreements-icon.vue'
import ContractorIcon from '@/components/icon/icons/navbar/Contractor-icon.vue'
import EmployeesIcon from '@/components/icon/icons/navbar/Employees-icon.vue'
import CorrespondenceIcon from '@/components/icon/icons/navbar/Correspondence-icon.vue'
import AdministrationIcon from '@/components/icon/icons/navbar/Administration-icon.vue'
import SignIcon from '@/components/icon/icons/navbar/SignIcon.vue'
import DocumentViewIcon from '@/components/icon/icons/navbar/DocumentViewIcon.vue'
import OrderIcon from '@/components/icon/icons/navbar/OrderIcon.vue'
import AuditIcon from '@/components/icon/icons/navbar/AuditIcon.vue'
import Pencil from './components/Pencil.vue'
import Delete from './components/Delete.vue'
import Key from './components/Key.vue'
import Copy from './components/Copy.vue'
import Archive from './components/Archive.vue'
import Telegram from './components/Telegram.vue'
import AccountMultiple from './components/AccountMultiple.vue'
import KeyMedia from './components/KeyMedia.vue'

export const intimeIcons = {
  home: HomeIcon,
  task: TasksIcon,
  agreements: AgreementsIcon,
  contractor: ContractorIcon,
  employees: EmployeesIcon,
  correspondence: CorrespondenceIcon,
  administration: AdministrationIcon,
  sign: SignIcon,
  'document-view': DocumentViewIcon,
  order: OrderIcon,
  audit: AuditIcon,
  pencil: Pencil,
  delete: Delete,
  key: Key,
  copy: Copy,
  archive: Archive,
  telegram: Telegram,
  'account-multiple': AccountMultiple,
  'key-media': KeyMedia,
}
